import React from "react";

export default function comoComprar(){


    return(
        <div>
            <h1>COMPRAR</h1>
        </div>
    )
}